import { WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';

// Cleans the authorization code/state from the URL after a successful login so
// it is not left in the address bar or browser history.
function onSigninCallback(): void {
  window.history.replaceState({}, document.title, window.location.pathname);
}

// When set (e.g. "Google"), every authorize request carries the
// identity_provider hint so the Hosted UI skips its account chooser and goes
// straight to that IdP. The pool client enforces which IdPs are allowed; this
// only smooths the redirect.
const identityProvider = import.meta.env.VITE_COGNITO_IDP;

export const oidcConfig: AuthProviderProps = {
  authority: import.meta.env.VITE_COGNITO_AUTHORITY,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_COGNITO_LOGOUT_URI,
  scope: import.meta.env.VITE_COGNITO_SCOPE ?? 'openid email profile',
  response_type: 'code',
  automaticSilentRenew: true,
  ...(identityProvider
    ? { extraQueryParams: { identity_provider: identityProvider } }
    : {}),
  // Persist the session so a page refresh does not require re-login.
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback,
};
